import BasicLayout from '@/layouts/Basic';

export default [
    // SDK里的跳转任务列表是创意中心默认链接，这里重定向到个人任务路由
    {
        path: '/inspiration/user/:userid/ai_digital_human_task',
        redirect: {
            path: '/user/:userid/ai/ai_digital_human_task'
        }
    },
    {
        path: '/user/:userid/ai',
        name: 'digitalConsole',
        component: BasicLayout,
        meta: {
            onlyV1: true
        },
        children: [
            {
                path: 'ai_digital_console',
                name: 'digitalConsole',
                meta: {
                    title: '数字人_首页',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'ai_digital_human_template',
                name: 'digitalVideoTemplate',
                meta: {
                    title: '数字人_模板列表页',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'ai_digital_human_list',
                name: 'DigicList',
                meta: {
                    title: '数字人_数字人列表页',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'ai_digital_human_task',
                name: 'digitalMy',
                meta: {
                    title: '数字人_任务列表页',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'ai_digital_human_content',
                name: 'DigitalAiContent',
                meta: {
                    title: '数字人_脚本文案',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'mashup_create',
                name: 'MashupCreate',
                meta: {
                    title: '一键成片',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                redirect: {
                    name: 'MashupCreateV2'
                },
                component: () => import('@/component/AIDigitalHuman/index')
            }
        ]
    }
];